import VectorProps from "./VectorProps";

export default function ExternallySyncedIcon(props: VectorProps) {
  const {
    className = "",
    fill = "currentColor",
    handleClick = () => null,
    height,
    width,
  } = props;
  // from https://www.figma.com/design/LyX9wbSKd81UvXFeq58wMx?node-id=3995-3915&main-component=1&fuid=1161329831925156001
  return (
    <svg
      className={className}
      fill={fill}
      height={height ?? width}
      onClick={handleClick}
      viewBox="0 0 20 20"
      width={width}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_21119_3432)">
        <path
          d="M3.80003 16.16C3.80003 16.16 3.71003 16.16 3.66003 16.15C1.29003 15.72 0.0300293 14.9 0.0300293 13.79C0.0300293 13.35 0.390029 12.99 0.830029 12.99C1.27003 12.99 1.63003 13.35 1.63003 13.79C1.69003 13.84 2.27003 14.28 3.94003 14.58C4.37003 14.66 4.66003 15.07 4.59003 15.51C4.52003 15.9 4.18003 16.17 3.80003 16.17V16.16Z"
          fill="#AEB5BC"
        />
        <path
          d="M0.830029 14.59C0.390029 14.59 0.0300293 14.23 0.0300293 13.79V2.65002C0.0300293 2.21002 0.390029 1.85002 0.830029 1.85002C1.27003 1.85002 1.63003 2.21002 1.63003 2.65002V13.78C1.63003 14.22 1.27003 14.58 0.830029 14.58V14.59Z"
          fill="#AEB5BC"
        />
        <path
          d="M13.01 10.8C12.57 10.8 12.21 10.44 12.21 10V2.65002C12.21 2.21002 12.57 1.85002 13.01 1.85002C13.45 1.85002 13.81 2.21002 13.81 2.65002V10C13.81 10.44 13.45 10.8 13.01 10.8Z"
          fill="#AEB5BC"
        />
        <path
          d="M6.92003 10.85C4.36003 10.85 0.0300293 10.3 0.0300293 8.22002C0.0300293 7.78002 0.390029 7.42002 0.830029 7.42002C1.27003 7.42002 1.63003 7.78002 1.63003 8.22002C1.80003 8.47002 3.59003 9.25002 6.92003 9.25002C7.67003 9.25002 8.40003 9.21002 9.09003 9.13002C9.53003 9.08002 9.93003 9.39002 9.98003 9.83002C10.03 10.27 9.72003 10.67 9.28003 10.72C8.53003 10.81 7.74003 10.86 6.92003 10.86V10.85Z"
          fill="#AEB5BC"
        />
        <path
          d="M6.92003 5.28002C4.36003 5.28002 0.0300293 4.73002 0.0300293 2.65002C0.0300293 0.57002 4.36003 0.0200195 6.92003 0.0200195C9.48003 0.0200195 13.81 0.57002 13.81 2.65002C13.81 4.73002 9.48003 5.28002 6.92003 5.28002ZM1.69003 2.65002C2.09003 3.01002 3.85003 3.68002 6.92003 3.68002C9.99003 3.68002 11.75 3.01002 12.15 2.65002C11.75 2.29002 9.99003 1.62002 6.92003 1.62002C3.85003 1.62002 2.09003 2.29002 1.69003 2.65002Z"
          fill="#AEB5BC"
        />
        <path
          d="M18.89 13.91H11.89C11.45 13.91 11.09 13.55 11.09 13.11C11.09 12.67 11.45 12.31 11.89 12.31H18.89C19.33 12.31 19.69 12.67 19.69 13.11C19.69 13.55 19.33 13.91 18.89 13.91Z"
          fill="#AEB5BC"
        />
        <path
          d="M16.55 16.15C16.3 16.15 16.05 16.03 15.89 15.81C15.64 15.45 15.72 14.95 16.08 14.7L17.78 13.11L16.08 11.5C15.72 11.25 15.63 10.75 15.89 10.39C16.14 10.03 16.64 9.94003 17 10.2L19.64 12.46C19.85 12.61 19.98 12.85 19.98 13.11C19.98 13.37 19.85 13.61 19.64 13.76L17 16C16.86 16.1 16.7 16.15 16.54 16.15H16.55Z"
          fill="#AEB5BC"
        />
        <path
          d="M13.65 17.76H6.65003C6.21003 17.76 5.85003 17.4 5.85003 16.96C5.85003 16.52 6.21003 16.16 6.65003 16.16H13.65C14.09 16.16 14.45 16.52 14.45 16.96C14.45 17.4 14.09 17.76 13.65 17.76Z"
          fill="#AEB5BC"
        />
        <path
          d="M8.95998 19.95C8.79998 19.95 8.63998 19.9 8.49998 19.8L5.89003 17.61C5.68003 17.46 5.55003 17.22 5.55003 16.96C5.55003 16.7 5.68003 16.46 5.89003 16.31L8.49998 14C8.85998 13.74 9.35998 13.83 9.60998 14.19C9.85998 14.55 9.77998 15.05 9.41998 15.3L7.75003 16.96L9.41998 18.5C9.77998 18.75 9.86998 19.25 9.60998 19.61C9.44998 19.83 9.20998 19.95 8.94998 19.95H8.95998Z"
          fill="#AEB5BC"
        />
      </g>
      <defs>
        <clipPath id="clip0_21119_3432">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
